<ng-container *transloco="let t; read: 'timeSupplements'">
  <h2 class="mbm">{{ t("title") }}</h2>
  <ng-container *ngIf="vm$ | async as vm">
    <kendo-grid
      [data]="{ data: vm.timeSupplements, total: vm.total }"
      [scrollable]="'none'"
      [sortable]="{
        allowUnsort: false
      }"
      [sort]="sort"
      (sortChange)="sortChange($event, vm.searchRequest)"
      [scrollable]="'none'"
      (edit)="editHandler($event)"
      (cancel)="cancelHandler($event)"
      (save)="saveHandler($event)"
      (add)="addHandler($event)"
      (remove)="showDeleteModal = $event.dataItem.id"
      [skip]="vm.gridState.skip"
      [pageSize]="vm.gridState.pageSize"
      [pageable]="true"
      (pageChange)="pageChangeSub$.next($event)"
      [resizable]="true"
    >
      <ng-template kendoGridToolbarTemplate>
        <a kendoGridAddCommand class="addIcon">
          <span class="icon">
            <kendo-svg-icon [icon]="addIcon"></kendo-svg-icon>
          </span>
          {{ t("add") }}
        </a>
      </ng-template>

      <kendo-grid-column
        field="validOnMonday"
        [title]="t('validOnMonday')"
        media="(min-width: 993px)"
        [width]="80"
        editor="boolean"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>{{ dataItem.validOnMonday ? t("yes") : t("no") }}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="validOnTuesday"
        [title]="t('validOnTuesday')"
        media="(min-width: 993px)"
        [width]="80"
        editor="boolean"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>{{ dataItem.validOnTuesday ? t("yes") : t("no") }}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="validOnWednesday"
        [title]="t('validOnWednesday')"
        media="(min-width: 993px)"
        [width]="80"
        editor="boolean"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>{{ dataItem.validOnWednesday ? t("yes") : t("no") }}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="validOnThursday"
        [title]="t('validOnThursday')"
        media="(min-width: 993px)"
        [width]="80"
        editor="boolean"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>{{ dataItem.validOnThursday ? t("yes") : t("no") }}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="validOnFriday"
        [title]="t('validOnFriday')"
        media="(min-width: 993px)"
        [width]="80"
        editor="boolean"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>{{ dataItem.validOnFriday ? t("yes") : t("no") }}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="validOnSaturday"
        [title]="t('validOnSaturday')"
        media="(min-width: 993px)"
        [width]="80"
        editor="boolean"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>{{ dataItem.validOnSaturday ? t("yes") : t("no") }}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="validOnSunday"
        [title]="t('validOnSunday')"
        media="(min-width: 993px)"
        [width]="80"
        editor="boolean"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>{{ dataItem.validOnSunday ? t("yes") : t("no") }}</span>
        </ng-template>
      </kendo-grid-column>

      <!-- <kendo-grid-column
        field="timeFrom"
        [title]="t('timeFrom')"
        media="(min-width: 993px)"
        [width]="120"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>{{ dataItem.timeFrom }}</span>
        </ng-template>
      </kendo-grid-column> -->

      <kendo-grid-column field="timeFrom" [title]="t('timeFrom')" width="100">
        <ng-template kendoGridCellTemplate let-dataItem>
          <input
            kendoTextBox
            [readonly]="true"
            [value]="dataItem.timeFromObj | timeSpanToString"
          />
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-formGroup="formGroup"
        >
          <input
            kendoTextBox
            [formControl]="formGroup.get('timeFrom')"
            placeholder="00:00"
          />
          <kendo-formerror
            *ngIf="
              formGroup.get('timeFrom')?.hasError('invalidTimeFormat') &&
              formGroup.get('timeFrom')?.touched
            "
            >{{ t("errors.wrongTimeFormat") }}</kendo-formerror
          >
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="timeTo" [title]="t('timeTo')" width="100">
        <ng-template kendoGridCellTemplate let-dataItem>
          <input
            kendoTextBox
            [readonly]="true"
            [value]="dataItem.timeToObj | timeSpanToString"
          />
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-formGroup="formGroup"
        >
          <input
            kendoTextBox
            [formControl]="formGroup.get('timeTo')"
            placeholder="00:00"
          />
          <kendo-formerror
            *ngIf="
              formGroup.get('timeTo')?.hasError('invalidTimeFormat') &&
              formGroup.get('timeTo')?.touched
            "
            >{{ t("errors.wrongTimeFormat") }}
          </kendo-formerror>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="percentage"
        [title]="t('percentage')"
        media="(min-width: 993px)"
        [width]="120"
        editor="numeric"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>{{ dataItem.percentage }}%</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column
        [hidden]="
          !('Permissions.TimeSupplements.Update' | permission) ||
          !('Permissions.TimeSupplements.Delete' | permission)
        "
        media="(min-width: 993px)"
        width="100"
      >
        <ng-template kendoGridCellTemplate let-isNew="isNew">
          <a
            kendoGridEditCommand
            [attr.tooltip]="t('edit')"
            flow="up"
            class="actionIcon"
            ><kendo-svg-icon [icon]="editIcon"></kendo-svg-icon>
          </a>
          <a
            kendoGridRemoveCommand
            [attr.tooltip]="t('delete')"
            flow="up"
            class="actionIcon"
            ><kendo-svg-icon [icon]="deleteIcon"></kendo-svg-icon>
          </a>
          <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
            {{ isNew ? t("add") : t("save") }}
          </button>
          <button kendoGridCancelCommand>
            {{ isNew ? t("cancel") : t("cancel") }}
          </button>
        </ng-template>
      </kendo-grid-command-column>

      <!-- MOBILE GRID -->
      <kendo-grid-column-group media="(max-width: 992px)">
        <kendo-grid-column>
          <ng-template kendoGridCellTemplate let-dataItem>
            <h4 class="mobileGridHeader">{{ t("name") }}</h4>
            <span>{{ dataItem.name }}</span>
          </ng-template>
          <ng-template
            kendoGridEditTemplate
            let-isNew="isNew"
            let-formGroup="formGroup"
          >
            <h4 class="mobileGridHeader">{{ t("name") }}</h4>
            <kendo-textbox
              [formControl]="formGroup.get('name')"
            ></kendo-textbox>
            <kendo-formerror
              *ngIf="
                formGroup.get('name').touched &&
                formGroup.get('name').hasError('required') &&
                !formGroup.get('name').value
              "
            >
              {{ t("isRequired") }}</kendo-formerror
            >
            <kendo-formerror
              *ngIf="
                formGroup.get('name').hasError('deviceManufacturerExists') &&
                formGroup.get('name').touched
              "
            >
              {{ t("isNotUnique") }}</kendo-formerror
            >
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-command-column
          [hidden]="
            !('Permissions.TimeSupplements.Update' | permission) ||
            !('Permissions.TimeSupplements.Delete' | permission)
          "
          media="(max-width: 992px)"
          width="100"
        >
          <ng-template kendoGridCellTemplate let-isNew="isNew">
            <a
              kendoGridEditCommand
              [attr.tooltip]="t('edit')"
              flow="up"
              class="actionIcon"
              ><kendo-svg-icon [icon]="editIcon"></kendo-svg-icon
            ></a>
            <a
              kendoGridRemoveCommand
              [attr.tooltip]="t('delete')"
              flow="up"
              class="actionIcon"
              ><kendo-svg-icon [icon]="deleteIcon"></kendo-svg-icon
            ></a>
            <button 
              kendoGridSaveCommand 
              [disabled]="formGroup?.invalid"
              loadingIndication="/timeSupplement/updateTimeSupplement"
              >
              {{ isNew ? t("add") : t("save") }}
            </button>
            <button kendoGridCancelCommand>
              {{ isNew ? t("cancel") : t("cancel") }}
            </button>
          </ng-template>
        </kendo-grid-command-column>
      </kendo-grid-column-group>

      <!-- IF NO RESULTS COULD BE FOUND -->
      <ng-template kendoGridNoRecordsTemplate>
        <div class="text pl">{{ t("noResults") }}</div>
      </ng-template>

      <!-- Paging -->
      <ng-template
        let-totalPages="totalPages"
        let-currentPage="currentPage"
        kendoPagerTemplate
      >
        <div class="flex flexDirRow">
          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
          <kendo-pager-numeric-buttons
            [buttonCount]="5"
          ></kendo-pager-numeric-buttons>
          <kendo-pager-next-buttons></kendo-pager-next-buttons>
        </div>
        <div>
          <label class="label" for="pageBtnGroup" class="mrs"
            >{{ t('resultsPerPage') }}</label
          >
          <kendo-buttongroup
            [selection]="'single'"
            id="pageBtnGroup"
            class="-purple"
          >
            <button
              (click)="
                pageChangeSub$.next({
                  skip: vm.gridState.skip,
                  take: pageSizes.Small
                })
              "
              kendoButton
              [selected]="vm.gridState.pageSize === pageSizes.Small"
              [toggleable]="true"
            >
              {{ pageSizes.Small }}
            </button>
            <button
              (click)="
                pageChangeSub$.next({
                  skip: vm.gridState.skip,
                  take: pageSizes.Medium
                })
              "
              kendoButton
              [selected]="vm.gridState.pageSize === pageSizes.Medium"
              [toggleable]="true"
            >
              {{ pageSizes.Medium }}
            </button>
            <button
              (click)="
                pageChangeSub$.next({
                  skip: vm.gridState.skip,
                  take: pageSizes.Large
                })
              "
              kendoButton
              [selected]="vm.gridState.pageSize === pageSizes.Large"
              [toggleable]="true"
            >
              {{ pageSizes.Large }}
            </button>
          </kendo-buttongroup>
        </div>
      </ng-template>
    </kendo-grid>

    <app-delete-confirm-dialog
      [opened]="!!showDeleteModal"
      [message]="t('deletionMessage')"
      (confirmed)="onDelete(showDeleteModal)"
      (cancelled)="showDeleteModal = null"
    ></app-delete-confirm-dialog>
  </ng-container></ng-container
>
